import React from 'react';
import "./ForInfluencersTech.scss";

export const ForInfluencersTech: React.FC = React.memo(() => {
    return (
        <div className="for-influencers-tech">
            <div className="header">
                <p className="title">
                    TECH SPECS FOR INFLUENCERS
                </p>
                <p className="subtitle">
                    Ready to dive into the chaos? Neuroborn Cats: From the dumpster to the throne.
                </p>
            </div>
            <div className="content">
                <div className="card-group">
                    <div className="card">
                        <div className="card-title">
                            Target Audience
                        </div>
                        <p className="card-text">
                            Adults (18+) tired of sanitized worlds. Fans of deep MMOs, cyberpunk, economic sims, and games with real consequences.
                        </p>
                    </div>
                    <div className="card">
                        <div className="card-title">
                            Key Selling Points
                        </div>
                        <p className="card-text">
                            Freedom of choice, a mature cynical world, a real NFT-driven economy, no Web3 entry barriers.
                        </p>
                    </div>
                </div>
                <div className="card">
                    <div className="card-title">
                        Content Potential
                    </div>
                    <ul className="card-text list">
                        <li>Guides: Leveling, economy, empire-building.</li>
                        <li>Roleplay: From a street thug to a crime lord.</li>
                        <li>Streams: PvP raids, territory control, trade operations, "from zero" playthroughs.</li>
                        <li>Reviews: Analysis of the unique setting and barrier-free Web3.</li>
                    </ul>
                </div>
            </div>
        </div>
    )
});